import { Modal } from 'react-bootstrap'
import './SubscriptionModal.scss'
import { Machine } from '../../utils/models/Machine'
import { useTranslation } from 'react-i18next';
import { ConnectionType, ConnectionTypeList } from '../../utils/const';
import { useEffect, useState } from 'react';
import { ISelectOptions } from 'aw-combobox';
import { Countries, CountriesList } from 'aw-consts';
import SubscriptionForm from './SubscriptionForm/SubscriptionForm.component';
import SubscriptionPayment from './SubscriptionPayment/SubscriptionPayment.component';
import { AnimatePresence, motion } from "framer-motion";
import { useSelector } from 'react-redux';
import { selectUser } from '../../utils/redux/userSlice';

const SubscriptionModal = (props: { showModal: boolean, onHide: () => void, machine: Machine, onChangeStateMachine: (active: boolean) => void }) => {
    const { t } = useTranslation();

    enum SubscriptionProcessState {
        Form,
        Payment,
        Completed
    }

    const allConnectionsOptions = ConnectionTypeList()
    const allCountriesOptions = CountriesList()
    const [processState, setProcessState] = useState<SubscriptionProcessState>(SubscriptionProcessState.Form)
    const [connection, setConnection] = useState<ISelectOptions | null>(null)
    const [country, setCountry] = useState<ISelectOptions | null>(null)
    const [agreedDocument1, setAgreedDocument1] = useState(false)
    const [agreedDocument2, setAgreedDocument2] = useState(false)

    const [priceId] = useState('price_1SCcaKLa6SyFutpvi4QHPdPX')
    const [trialDays] = useState(30)
    const [price] = useState(1.00)

    const [validForm, setValidForm] = useState(false)


    useEffect(() => {
        if (connection != null && country != null && agreedDocument1 && agreedDocument2)
            setValidForm(true)
        else
            setValidForm(false)
    }, [connection, country, agreedDocument1, agreedDocument2])

    const onClickNext = () => {
        if (processState === SubscriptionProcessState.Form) {
            setProcessState(SubscriptionProcessState.Payment)
        } else if (processState === SubscriptionProcessState.Payment) {
            setProcessState(SubscriptionProcessState.Completed)
        } else if (processState === SubscriptionProcessState.Completed) {
            setProcessState(SubscriptionProcessState.Form)
            props.onChangeStateMachine(true)
            props.onHide()
        }
    }

    const onClickCancel = () => {
        console.log('onClickCancel', processState);
        if (processState === SubscriptionProcessState.Payment) {
            setProcessState(SubscriptionProcessState.Form)
        }
        props.onHide()
    }

    const getNextButtonLabel = () => {
        if (processState === SubscriptionProcessState.Form) {
            return t('Next')
        } else if (processState === SubscriptionProcessState.Payment) {
            return t('CompletePayment')
        } else if (processState === SubscriptionProcessState.Completed) {
            return t('Close')
        }
    }

    const onCheckedDocument1 = (e: any) => {
        setAgreedDocument1(e.target.checked)
    }

    const onCheckedDocument2 = (e: any) => {
        setAgreedDocument2(e.target.checked)
    }

    return (
        <>
            <Modal show={props.showModal} keyboard={false} backdrop={'static'}>
                <Modal.Body className='modalBodyParent'>
                    <header className='modalHeader px-3 py-2'>
                        <span className='h4'>{t('ActivateMachine')} <span >{props.machine.name}</span></span>
                        <div className='d-flex flex-row my-2'>
                            <div className='priceBox px-3 py-1 me-3'><span>{`${t('Trial')}: ${trialDays} ${t('Days')}`}</span></div>
                            <div className='priceBox px-3 py-1 me-3'><span>{`${t('Price')}: ${price}€/${t('Year')}`}</span></div>
                            {/* <div className='priceBox px-3 py-1'><span>{`${t('i')}`}</span></div> */}
                        </div>
                    </header>
                    <div className='modalBody px-3 py-3'>
                        <AnimatePresence mode="wait">
                            {processState === SubscriptionProcessState.Form &&
                                <motion.div
                                    key="form"
                                    initial={{ opacity: 0, x: -20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: 20 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <SubscriptionForm onChangeCountry={(e) => setCountry(e)} countryOptions={allCountriesOptions}
                                        onChangeConnection={(e) => setConnection(e)} connectionOptions={allConnectionsOptions} onCheckedDocument2={onCheckedDocument2} onCheckedDocument1={onCheckedDocument1} />
                                </motion.div>}
                            {[SubscriptionProcessState.Payment].includes(processState) &&
                                <motion.div
                                    key="payment"
                                    initial={{ opacity: 0, x: 20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: -20 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <SubscriptionPayment onCompletePayment={onClickNext} machine={props.machine} connection={connection?.value as number || ConnectionType.Sim} country={country?.value as number || Countries.Spain} priceId={priceId} trialDays={trialDays} />
                                </motion.div>}

                            {[SubscriptionProcessState.Completed].includes(processState) &&
                                <motion.div
                                    key="Completed"
                                    initial={{ opacity: 0, x: 20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: -20 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <SubscriptionThankYou />
                                </motion.div>}
                        </AnimatePresence>
                    </div>
                    <footer className='d-flex flex-column px-3 py-2'>
                        {processState != SubscriptionProcessState.Payment && <button disabled={!validForm} className='btn-Custom btn-IDGreen mb-2' onClick={onClickNext}>{getNextButtonLabel()}</button>}
                        {processState != SubscriptionProcessState.Completed && <button className='btn-Custom btn-Grey mb-2' onClick={onClickCancel}>{t('Cancel')}</button>}
                    </footer>
                </Modal.Body>
            </Modal >
        </>
    )
}

const TickIcon = () => (
    <svg width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="11" stroke="#2ecc71" strokeWidth="1.5" fill="white" />
        <path d="M7.5 12.5l2.5 2.5L16.5 9" stroke="#2ecc71" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const SubscriptionThankYou = () => {
    const { t } = useTranslation();
    return (
        <div className="thankyou-card border rounded-3 shadow-sm bg-white p-4" style={{ maxWidth: 520, margin: "0 auto" }}>
            <div className="text-center py-3">
                <div className="icon-wrap mb-2">
                    <TickIcon />
                </div>
                <h5 className="fw-semibold mb-2">{t('ThakyouForSubscribe')}</h5>
                <p className="text-muted small mb-0">
                    {t('AfterTrialPeriodPaymentStripeAppearOnYourStatement.')}
                </p>
            </div>

            {/* Ticket box */}
            <div className="ticket-box my-4 mx-2">
                <div className="ticket-left px-3 py-3">
                    <div className="small text-uppercase text-muted"> {'Demo Stripe'} </div>
                </div>
                <div className="ticket-right px-3 py-3 text-end">
                    <div className="h5 mb-0">{'1.00'} <span className="small">{'€'}</span></div>
                </div>
                <div className="ticket-teeth" aria-hidden />
            </div>

            {/* Footer */}
            <div className="d-flex justify-content-between align-items-center mt-3 px-2">
                <div className="powered small text-muted d-flex align-items-center gap-1">
                    <span>Powered by</span>
                    <span>Awayter</span>
                </div>


            </div>

        </div >
    )
};

export default SubscriptionModal